import { Stack, Typography, useTheme } from "@mui/material";
import calendarNoData from "assets/images/nodata/calendarNoData.png";

export const CalendarEmptyState = () => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100%", gap: "16px", px: "24px" }}
    >
      <img
        src={calendarNoData}
        alt="No calendar events"
        style={{ width: "134px", height: "auto" }}
      />
      <Stack alignItems="center" gap="4px">
        <Typography
          variant="subtitle1"
          sx={{ color: theme.palette.lightBg.high }}
        >
          Your schedule is clear
        </Typography>
        <Typography
          variant="body-small"
          sx={{ color: theme.palette.lightBg.low, textAlign: "center" }}
        >
          No tickets or activities are scheduled.
        </Typography>
      </Stack>
    </Stack>
  );
};
